export function mapButtonStatus(response: 'zichtbaar' | 'verborgen'): 'visble' | 'hidden' {
    return response === 'zichtbaar' ? 'visble' : 'hidden';
}
